import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import {uiReducer} from './uiReducer';
import { userReducer } from './userReducer';
import { docketReducer } from './docketReducer';
import { docketGeneralInfoReducer } from './docketGeneralInfoReducer';
import { documentActivityReducer } from './documentActivityReducer';
import { createForms } from 'react-redux-form';
import { DataTableReducer } from 'react-redux-datatable';


export default combineReducers({
  routing,
	  DataTableReducer,
  uiState:uiReducer,
  userData:userReducer,
  docketData:docketReducer,
  // docketStatus:docketReducer,
  docketGeneralInfo:docketGeneralInfoReducer,
  documentActivity:documentActivityReducer,
  ...createForms({
	
	eServiceForm: {
		e_services:''
	},
	
    myDocketform: {
      uniqueCode:'',
	  e_services:''
    },
	findCaseform: {
      uniqueCode:'',
	  e_services:''
    },
	createAccount:
	{
		email:'',
		user_password:'',
		cnf_password:'',
		first_name:'',
		user_type:'',
		last_name:''
		
	},
	uploadFile:
	{
		// datesubmitted:'',
		docketno:'',
		documentType:'',
		documentName:'',
		description:'',
		files:[]
	},
	forgotPassword:
	{
		email:''
	},
	resetPassword:
	{
		new_password:'',
		cnf_password:''
	},
	userDetails:
	{
		email:'',
		first_name:'',
		last_name:'',
		current_password:'',
		new_password:'',
		cnf_password:'',
		barno:''
	}
	
  }),
})